import React, { ReactElement, ReactNode } from "react";

interface CombinedProviderProps {
  providers: ReactElement[];
  children: ReactNode;
}

const CombinedProvider: React.FC<CombinedProviderProps> = ({
  providers,
  children,
}) => {
  return providers.reduceRight(
    (acc, Provider) => {
      return React.cloneElement(Provider, {}, acc);
    },
    <>{children}</>,
  );
};

export { CombinedProvider };
